import React from "react";
import { useDraggable } from "@dnd-kit/core";
import "./index.css";

export function Draggable(props) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: props.id,
  });

  const style = {
    position: "absolute",
    transform: transform
      ? `translate3d(${props.position.x + transform.x}px, ${
          props.position.y + transform.y
        }px, 0)`
      : `translate3d(${props.position.x}px, ${props.position.y}px, 0)`,
    cursor: "move",
    width: "auto", // Maintain aspect ratio
    height: props.height,
    aspectRatio: props.aspectRatio,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="reservations-schema-draggable-container"
      onClick={(e) => {
        if (e.detail === 2) {
          props.onDoubleClick(props.id);
        }
      }}
    >
      <img
        src={props.src}
        alt={props.alt}
        style={{
          transform: `rotate(${props.direction}deg)`,
          transition: "transform 0.5s ease",
        }}
        className="reservations-schema-table-image"
      />
      <div className="reservations-schema-image">
        <span className="reservations-schema-image-text">
          {props.tableName}
        </span>
      </div>
    </div>
  );
}
